// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.siteheader {
  display: flex;
  flex-direction: column;
  width: 80%;
  margin: 0;
  padding: 0 0 1rem 0;
  background: hsl(200, 20%, 12%);
  border-radius: 1rem;
  box-shadow: 0 10px 40px -15px hsla(0, 0%, 0%, 0.5);
  max-width: 50rem;
  border-radius: 0 0 1rem 1rem;
}
.siteheader__top {
  min-height: 150px;
  padding: 1rem;
}
@media (min-width: 480px) {
  .siteheader__top {
    width: 80%;
    margin: 0 auto;
  }
}
.siteheader__heading {
  text-transform: uppercase;
  font-size: 3rem;
  font-family: "Bebas Neue", sans-serif;
  letter-spacing: 0.05em;
  margin-bottom: 0.5rem;
}
@media (min-width: 480px) {
  .siteheader__heading {
    font-size: 4rem;
  }
}
.siteheader__heading--jason {
  color: hsl(190, 70%, 45%);
}
.siteheader__heading--ipsum {
  color: hsl(180, 15%, 92%);
}
.siteheader__text {
  font-size: 1.25rem;
  color: hsl(200, 10%, 55%);
  font-family: "Inter", Arial, Helvetica, sans-serif;
  margin-bottom: 1rem;
}
@media (min-width: 480px) {
  .siteheader__text {
    font-size: 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SiteHeader/SiteHeader.scss","webpack://./src/styles/partials/_variables.scss","webpack://./src/styles/partials/_mixins.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EAEA,8BCGa;EDFb,mBCJU;EDKV,kDCgBU;EDdV,gBAAA;EAEA,4BAAA;AALJ;AAOI;EACI,iBAAA;EACA,aAAA;AALR;AEdI;EFiBA;IAKQ,UAAA;IACA,cAAA;EAJV;AACF;AAOI;EACI,yBAAA;EACA,eAAA;EACA,qCC3BO;ED4BP,sBAAA;EACA,qBAAA;AALR;AE3BI;EF2BA;IAOQ,eAAA;EAHV;AACF;AAKQ;EACI,yBCzBI;ADsBhB;AAKQ;EACI,yBC9BA;AD2BZ;AAOI;EACI,kBAAA;EACA,yBC7BU;ED8BV,kDC5CI;ED6CJ,mBAAA;AALR;AE5CI;EF6CA;IAMQ,iBAAA;EAHV;AACF","sourcesContent":["@use \"../../styles/partials/mixins\" as *;\n@use \"../../styles/partials/variables\" as *;\n\n.siteheader {\n    display: flex;\n    flex-direction: column;\n    width: 80%;\n    margin: 0;\n    padding: 0 0 1rem 0;\n\n    background: $colour-surface;\n    border-radius: $radius-card;\n    box-shadow: $shadow-card;\n\n    max-width: 50rem;\n\n    border-radius: 0 0 1rem 1rem;\n\n    &__top {\n        min-height: 150px;\n        padding: 1rem;\n\n        @include breakpoint($breakpoint-tablet) {\n            width: 80%;\n            margin: 0 auto;\n        }\n    }\n\n    &__heading {\n        text-transform: uppercase;\n        font-size: 3rem;\n        font-family: $font-display;\n        letter-spacing: 0.05em;\n        margin-bottom: 0.5rem;\n        @include breakpoint($breakpoint-tablet) {\n            font-size: 4rem;\n        }\n\n        &--jason {\n            color: $colour-accent;\n        }\n        &--ipsum {\n            color: $colour-fg;\n        }\n    }\n\n    &__text {\n        font-size: 1.25rem;\n        color: $colour-muted-fg;\n        font-family: $font-body;\n        margin-bottom: 1rem;\n        @include breakpoint($breakpoint-tablet) {\n            font-size: 1.5rem;\n        }\n    }\n}\n","$breakpoint-mobile: 320px;\n$breakpoint-tablet: 480px;\n$breakpoint-desktop: 768px;\n\n$font-display: \"Bebas Neue\", sans-serif;\n$font-body: \"Inter\", Arial, Helvetica, sans-serif;\n\n$radius-card: 1rem;\n$radius-pill: 2rem;\n$radius: 0.75rem;\n\n$colour-bg: hsl(200, 25%, 8%);\n$colour-fg: hsl(180, 15%, 92%);\n$colour-surface: hsl(200, 20%, 12%);\n$colour-accent: hsl(190, 70%, 45%);\n$colour-accent-light: hsl(185, 75%, 55%);\n$colour-accent-dark: hsl(195, 65%, 35%);\n$colour-surface-alt: hsl(200, 20%, 18%);\n$colour-muted: hsl(200, 15%, 20%);\n$colour-muted-fg: hsl(200, 10%, 55%);\n$colour-border: hsl(200, 15%, 22%);\n$colour-error: hsl(0, 70%, 50%);\n$colour-error-light: hsl(0, 70%, 60%);\n\n$gradient-ocean: linear-gradient(135deg, hsl(195, 65%, 35%), hsl(190, 70%, 45%), hsl(185, 75%, 55%));\n$gradient-dark: linear-gradient(180deg, hsl(200, 25%, 8%), hsl(200, 30%, 5%));\n\n$shadow-ocean: 0 4px 30px -10px hsl(190, 70%, 45%, 0.4);\n$shadow-card: 0 10px 40px -15px hsl(0, 0%, 0%, 0.5);\n$shadow-error: 0 4px 20px -5px hsl(0, 70%, 50%, 0.6);\n","@mixin breakpoint($breakpoint) {\n    @media (min-width: $breakpoint) {\n        @content;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
